import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, signal } from '@angular/core';
import { PermissionLevel, PropertySet } from '@miq/domain/property-sets';
import { PropertySetDetailsMode, PropertySetsState } from '../../property-sets-dialog/property-sets-dialog';
import { STATE_PROVIDER, StateProvider } from '../../services/state-provider/state-provider';
import { User } from '@miq/user';
import { getPropertyTypeLabel } from '@miq/utils';

@Component({
  selector: 'miq-property-set-summary',
  templateUrl: './property-set-summary.component.html',
  styleUrls: ['./property-set-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PropertySetSummaryComponent implements OnInit {
  public readonly UserPermissionLevel = PermissionLevel;
  public isUSResearcher = false;
  $propertySet = signal<PropertySet>(null);

  @Input() user: User;
  @Input() set propertySet(propertySet: PropertySet) {
    const property_type: string[] = propertySet?.property_type?.map(pt => getPropertyTypeLabel(pt)) || [];
    propertySet = { ...propertySet, property_type };
    this.$propertySet.set(propertySet);
  }

  constructor(@Inject(STATE_PROVIDER) private propertySetDetailsState: StateProvider<PropertySetsState>) {}

  ngOnInit(): void {
    this.isUSResearcher = this.user?.roleId === 1;
  }

  toggleEditMode() {
    this.propertySetDetailsState.patchState({ mode: PropertySetDetailsMode.Edit });
  }
}
